var React = require('react');

function AsanaBow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M27.031,14.758l-8.295,8.009l-9.819-3.704\n\tl2.917-9.785 M32.119,14.368l3.107-3.069c0,0-3.216-3.939-3.817-4.574c-1.814-1.917-4.237-2.568-6.72-0.217\n\tc-2.482,2.349-1.965,4.805-0.152,6.72c0.604,0.635,2.117,1.894,2.117,1.894 M8.079,8.077C4.255,16.274,3,18,3,20\n\tc0,1.156,0.589,2.437,1.447,3.283C8.854,27.635,13.362,31,19,31c6.333,0,12-7.327,12-10.617c0-2.973-1.263-4.1-4.346-5.261\n\tC5.438,7.125,5.438,7.125,5.438,7.125"}));
}

AsanaBow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaBow;

AsanaBow.default = AsanaBow;
